import React, { useEffect, useState } from "react";
import moment from "moment";
import mainAxios from "../../../redux/api/mainAxios";
import toast from "react-hot-toast";

const EditProgramModal = ({ programme }) => {
  const [formData, setFormData] = useState({
    name: programme?.name || "",
    progress: programme?.progress || "",
    description: programme?.description || "",
    delivery_date: moment(programme.delivery_date).format("YYYY-MM-DD") || "",
    zone_fiscale: programme?.zone_fiscale || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditProgram = async () => {
    // Handle edit program logic
    try {
      const response = await mainAxios.put(
        `${process.env.REACT_APP_ENDPOINT_URL}api/programmes/${programme.documentId}`,
        {
          data: {
            ...formData,
            progress: parseInt(formData.progress),
          },
        }
      );
      toast.success("Programme mis à jour avec succès");
      //dispatch(fetchSingleProgramme(programme.documentId));
    } catch (error) {
      console.error("error", error);
      toast.error("Echec de la mise à jour du programme");
    }
  };

  return (
    <div className="w100 d-flex flex-column">
      <div>
        <p className="semibold pink fs16">Fiche du Programme</p>
        <hr />
      </div>
      <div className="d-flex gap40">
        {/* Left Column */}
        <div className="w50 d-flex flex-column gap20">
          <div>
            <label htmlFor="name">Nom</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <label htmlFor="progress">Progress</label>
            <input
              type="text"
              id="progress"
              name="progress"
              value={formData.progress}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <label htmlFor="description">Description</label>
            <textarea
              type="text"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <label htmlFor="delivery_date">Date de livraison</label>
            <input
              type="date"
              id="delivery_date"
              name="delivery_date"
              value={formData.delivery_date}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
          <div>
            <label htmlFor="zone_fiscale">Zone fiscale</label>
            <input
              type="text"
              id="zone_fiscale"
              name="zone_fiscale"
              value={formData.zone_fiscale}
              onChange={handleChange}
              className="w100 customInput"
            />
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-20">
        <button
          onClick={handleEditProgram}
          className={`radius5 px-20 py-1 white border-0 hoverOpacity bg-pink`}
        >
          Appliquer
        </button>
      </div>
    </div>
  );
};

export default EditProgramModal;
